/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */
import type { ButtonActionType } from './buttonActionType'
import type { Cuid } from './cuid'
import type { RecordStringUnknown } from './recordStringUnknown'
import type { ScenarioButtonPosition } from './scenarioButtonPosition'
import type { ScenarioButtonStyle } from './scenarioButtonStyle'

export interface ScenarioButton {
  updatedAt: string
  createdAt: string
  order: number
  /** @nullable */
  style: ScenarioButtonStyle
  /** @nullable */
  position: ScenarioButtonPosition
  actionConfig: RecordStringUnknown
  actionType: ButtonActionType
  label: string
  nodeId: Cuid
  id: Cuid
}
